import { useQuery } from "react-query";
import { IeLynxObject } from "../../common/models/eLynxObject";
import AttributeDataService from "../../services/attribute-data-service/AttributeDataService";
import { IAttribute } from "../../services/attribute-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";



export type UseObjectAttributesQueryParams = {
    groupID: number, 
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IAttribute[]>;


export function useObjectAttributes(params: UseObjectAttributesQueryParams) {
    return useQuery<Array<IAttribute>, RestError>(
        keys.attributes(params.groupID, params.eLynxObject),
        ({ signal }) => {
            return AttributeDataService.getAttributes(params.groupID, params.eLynxObject, signal);
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false
        }
    );
}
